var _style, _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 480 480",
    style: {
      enableBackground: "new 0 0 480 480"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F5F5F5;}\n\t.st1{fill:url(#SVGID_1_);}\n")), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 240,
    cy: 240,
    rx: 232.1,
    ry: 233.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 240,
    y1: 2,
    x2: 240,
    y2: 482,
    gradientTransform: "matrix(1 0 0 -1 0 482)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#12C2E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05600001,
    style: {
      stopColor: "#19BFE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.137,
    style: {
      stopColor: "#2DB6EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.235,
    style: {
      stopColor: "#4DA7EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.344,
    style: {
      stopColor: "#7993EB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    style: {
      stopColor: "#B279ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497,
    style: {
      stopColor: "#C471ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F64F59"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M240,480c132.5,0,240-107.5,240-240S372.5,0,240,0S0,107.5,0,240C0.1,372.5,107.5,479.9,240,480z M240,16 c123.7,0,224,100.3,224,224S363.7,464,240,464S16,363.7,16,240C16.1,116.3,116.3,16.1,240,16z M240,376c45.8-0.2,88.8-22,115.9-58.8 c1.3-1.8,1.8-4.2,1.4-6.4c-9.3-42.4-40.7-76.5-82.2-89.4c23.6-15.5,34.3-44.7,26.2-71.8c-8.1-27.1-33-45.7-61.3-45.7 s-53.2,18.6-61.3,45.7c-8.1,27.1,2.5,56.3,26.2,71.8c-41.5,12.8-72.9,46.9-82.2,89.3c-0.5,2.2,0,4.6,1.4,6.4 C151.2,354,194.2,375.8,240,376z M192,168c0-26.5,21.5-48,48-48s48,21.5,48,48s-21.5,48-48,48C213.5,216,192,194.5,192,168z  M240,232c47.6,0.2,89,32.5,100.8,78.6C316.6,341.8,279.4,360,240,360c-39.4,0-76.7-18.2-100.8-49.4 C150.9,264.5,192.4,232.2,240,232z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.e809633034d1a7eca30500934501faf0.svg";
export { ForwardRef as ReactComponent };